import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactContent from '../../components/Content/ContactContent';
import { Wrapper, FormBox, Description } from './Contact.styles';

export default function Contact() {
  return (
    <Wrapper>
      <Helmet>
        <title>Contacto · Trastero</title>
        <meta name="description" content="¿Tienes alguna pregunta o sugerencia? Contacta con el equipo de Trastero." />
      </Helmet>
      <FormBox>
        <Description>
          ¿Tienes alguna pregunta, sugerencia o problema? Nos encantaría escucharte.
          Completa el formulario a continuación y nos pondremos en contacto pronto.
        </Description>
        <ContactContent />
      </FormBox>
    </Wrapper>
  );
}
